import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import {
  getDashboardWorkspaceCardSx,
  getDashboardWorkspaceHeaderSx,
  getDashboardWorkspaceSubtitleSx,
  getDashboardWorkspaceSummaryChipSx,
  getDashboardWorkspaceTitleSx,
} from '../../utils/dashboardWorkspaceLayout';

export default function DashboardWorkspaceCard({
  themeMode = 'dark',
  title,
  subtitle,
  headerActions = null,
  summaryChips = [],
  minHeight = { xs: 320, lg: 0 },
  maxHeight = '100%',
  denseHeader = false,
  children,
}) {
  return (
    <Box sx={getDashboardWorkspaceCardSx(themeMode, { minHeight, maxHeight })}>
      {(title || subtitle || headerActions || summaryChips.length > 0) && (
        <Box
          sx={{
            ...getDashboardWorkspaceHeaderSx(themeMode),
            ...(denseHeader ? { py: 0.75, pb: 0.65 } : null),
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
            <Box sx={{ minWidth: 0 }}>
              {title ? <Typography sx={getDashboardWorkspaceTitleSx(themeMode)}>{title}</Typography> : null}
              {subtitle ? (
                <Typography sx={getDashboardWorkspaceSubtitleSx(themeMode)}>{subtitle}</Typography>
              ) : null}
            </Box>
            {headerActions ? (
              <Box sx={{ flexShrink: 0, ml: 'auto', display: 'flex', alignItems: 'center', minWidth: 0 }}>
                {headerActions}
              </Box>
            ) : null}
          </Box>

          {summaryChips.length > 0 ? (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: title || subtitle ? 1 : 0 }}>
              {summaryChips.map((chip) => (
                <Chip
                  key={chip.key || chip.label}
                  size="small"
                  label={chip.label}
                  sx={getDashboardWorkspaceSummaryChipSx(themeMode, chip.color)}
                />
              ))}
            </Box>
          ) : null}
        </Box>
      )}

      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>{children}</Box>
    </Box>
  );
}
